import React from 'react';
import MainLayoutStyles from '../../styles/MainLayoutStyle';
const RightTabListLevel = (props) => {
  const classes = MainLayoutStyles();
  return (
    <div>
      <span role="presentation" onClick={props.clickFn}>
        <button type="submit" className={classes.menuPlusButton}>
          Add Level +
        </button>
      </span>
    </div>
  );
};

export default RightTabListLevel;
